import axiosClient from '../libs/axios';

// Google OAuth Configuration
const GOOGLE_CLIENT_ID = '18775372797-qpmrbllf25im9s87djjkmc64srs5cfc4.apps.googleusercontent.com';

// Google OAuth servisleri
export const googleAuth = {
  // Google OAuth URL oluştur
  getAuthUrl: () => {
    const redirectUri = `${window.location.origin}/auth/google/callback`;
    const scope = 'openid email profile';
    const state = Math.random().toString(36).substring(7);
    
    const params = new URLSearchParams({
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: scope,
      state: state,
      access_type: 'offline',
      prompt: 'consent'
    });

    return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  },

  // Google OAuth callback işlemi
  handleCallback: async (code, state) => {
    try {
      const response = await axiosClient.post('/auth/google/callback', {
        code: code,
        state: state
      });
      
      return response.data;
    } catch (error) {
      console.error('Google OAuth callback error:', error);
      throw error;
    }
  },

  // Google ile giriş yap
  loginWithGoogle: async (googleToken) => {
    try {
      const response = await axiosClient.post('/auth/google', {
        token: googleToken
      });
      
      return response.data;
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    }
  },

  // Google OAuth popup aç
  openGoogleAuthPopup: () => {
    return new Promise((resolve, reject) => {
      const authUrl = googleAuth.getAuthUrl();
      const popup = window.open(
        authUrl,
        'google-auth',
        'width=500,height=600,scrollbars=yes,resizable=yes'
      );

      if (!popup) {
        reject(new Error('Popup blocked'));
        return;
      }

      // Popup'ı izle
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed);
          reject(new Error('User closed popup'));
        }
      }, 1000);

      // Popup'tan gelen mesajları dinle
      const messageListener = (event) => {
        if (event.origin !== window.location.origin) {
          return;
        }

        if (event.data.type === 'GOOGLE_AUTH_SUCCESS') {
          clearInterval(checkClosed);
          window.removeEventListener('message', messageListener);
          popup.close();
          resolve(event.data.token);
        } else if (event.data.type === 'GOOGLE_AUTH_ERROR') {
          clearInterval(checkClosed);
          window.removeEventListener('message', messageListener);
          popup.close();
          reject(new Error(event.data.error));
        }
      };

      window.addEventListener('message', messageListener);
    });
  }
};

// Google OAuth callback sayfası için yardımcı fonksiyon
export const handleGoogleCallback = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const error = urlParams.get('error');

  if (error) {
    window.opener?.postMessage({
      type: 'GOOGLE_AUTH_ERROR',
      error: error
    }, window.location.origin);
    return;
  }

  if (code) {
    // Token'ı parent window'a gönder
    window.opener?.postMessage({
      type: 'GOOGLE_AUTH_SUCCESS',
      token: code
    }, window.location.origin);
  }
};

export default googleAuth;